import { render, staticRenderFns } from "./uniformChoose.vue?vue&type=template&id=5204b076&scoped=true&"
import script from "./uniformChoose.vue?vue&type=script&lang=js&"
export * from "./uniformChoose.vue?vue&type=script&lang=js&"
import style0 from "./uniformChoose.vue?vue&type=style&index=0&id=5204b076&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5204b076",
  null
  
)

export default component.exports